import type { ReactElement } from 'react';
import { HoverTooltip } from './HoverTooltip';

export type TimeBasedStatusColor = 'GREEN' | 'YELLOW' | 'ORANGE' | 'RED';

export type TimeBasedStatusEntry = {
  date: string;
  color: TimeBasedStatusColor;
  info?: string;
};

type TimeBasedStatusProps = {
  entries: TimeBasedStatusEntry[];
};

const COLOR_CLASSES: Record<TimeBasedStatusColor, string> = {
  GREEN: 'bg-emerald-500',
  YELLOW: 'bg-yellow-400',
  ORANGE: 'bg-orange-500',
  RED: 'bg-red-500',
};

export function TimeBasedStatus({ entries }: TimeBasedStatusProps): ReactElement {
  const sortedEntries = [...entries].sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
  );

  return (
    <div className="flex h-8 items-end gap-0.5">
      {sortedEntries.map((entry, index) => (
        <HoverTooltip
          key={`${entry.date}-${index}`}
          className="h-full items-end"
          content={
            <>
              <div className="font-semibold">{entry.date}</div>
              {entry.info ? <div className="whitespace-pre-line">{entry.info}</div> : null}
            </>
          }
        >
          <div className={`h-full w-2 cursor-pointer rounded-sm ${COLOR_CLASSES[entry.color]}`} />
        </HoverTooltip>
      ))}
    </div>
  );
}
